// extracted by mini-css-extract-plugin
export var blue = "_1s-f";
export var brand = "_1s-b";
export var darkGrey = "_1s-e";
export var disabled = "_1s-4";
export var disabledSubtle = "_1s-5";
export var error = "_1s-6";
export var green = "_1s-g";
export var grey = "_1s-d";
export var icon = "_1s-0";
export var inherit = "_1s-a";
export var lightGrey = "_1s-c";
export var orange = "_1s-i";
export var pink = "_1s-k";
export var primary = "_1s-1";
export var purple = "_1s-l";
export var red = "_1s-j";
export var secondary = "_1s-2";
export var success = "_1s-9";
export var tertiary = "_1s-3";
export var warning = "_1s-7";
export var warningSecondary = "_1s-8";
export var white = "_1s-m";
export var yellow = "_1s-h";